type Stages =
  "prod" | "test" | "int" | "local" | "demo" | "ocf-dev" | "ocf-prod";

const stage = process.env.NODE_ENV as Stages;

const prod = {
  serverUrl: "https://backoffice.loql.com",
  newBackofficeUrl: "https://bo.loql.com",
  appUrl: "https://app.loql.com",
  clientID:
    "844594414309-b9t5b9e422he3ul7hsc4jmh8actonfoq.apps.googleusercontent.com",
  fetchLimit: 10,
  resetPasswordUrl: "https://access.loql.com/users/reset-password",
};

const test = {
  serverUrl: "https://backoffice.loql-test.com",
  newBackofficeUrl: "https://bo.loql-test.com",
  appUrl: "https://app.loql-test.com",
  clientID:
    "664378371926-pso1oioligerqlubd4lj2eedaqokfv2v.apps.googleusercontent.com",
  fetchLimit: 10,
  resetPasswordUrl: "https://access.loql-test.com/users/reset-password",
};

const int = {
  serverUrl: "https://backoffice.loql-integration.com",
  newBackofficeUrl: "https://bo.loql-integration.com",
  appUrl: "https://app.loql-integration.com",
  clientID:
    "589761355217-7oddbm242uavvalir7ebpr4cob8kogjv.apps.googleusercontent.com",
  fetchLimit: 10,
  resetPasswordUrl: "https://access.loql-integration.com/users/reset-password",
};

const demo = {
  serverUrl: "https://backoffice.loql-demo.com",
  newBackofficeUrl: "https://bo.loql-demo.com",
  appUrl: "https://app.loql-demo.com",
  clientID:
    "673136253431-ndt2bjnnhuim7dh5ojpgcpcrarvq35vj.apps.googleusercontent.com",
  fetchLimit: 10,
  resetPasswordUrl: "https://access.loql-demo.com/users/reset-password",
};

const local = {
  serverUrl: import.meta.env.VITE_SERVER_URL || "http://localhost:9090",
  newBackofficeUrl: "https://bo.loql-test.com",
  appUrl: "http://app.loql-test.com",
  clientID:
    "664378371926-pso1oioligerqlubd4lj2eedaqokfv2v.apps.googleusercontent.com",
  fetchLimit: 10,
  resetPasswordUrl:
    import.meta.env.VITE_RESET_PASSWORD_URL ||
    "http://localhost:3001/users/reset-password",
};

const ocFlowDev = {
  serverUrl: "https://backoffice.ocflow-dev.com",
  newBackofficeUrl: "https://bo.ocflow-dev.com",
  appUrl: "https://app.ocflow-dev.com",
  clientID:
    "987780404646-lhdivkeckgauvn7lrovudpit513d5e3a.apps.googleusercontent.com",
  fetchLimit: 10,
  resetPasswordUrl: "https://access.ocflow-dev.com/users/reset-password",
};

const ocFlowProd = {
  serverUrl: "https://backoffice.ocflow.com",
  newBackofficeUrl: "https://bo.ocflow.com",
  appUrl: "https://app.ocflow.com",
  clientID:
    "881038848120-e3h9b48kprapst513d1fs2n53c78v6s1.apps.googleusercontent.com",
  fetchLimit: 10,
  resetPasswordUrl: "https://access.ocflow.com/users/reset-password",
};

function getProperties() {
  switch (stage) {
    case "prod":
      return prod;
    case "test":
      return test;
    case "int":
      return int;
    case "demo":
      return demo;
    case "ocf-dev":
      return ocFlowDev;
    case "ocf-prod":
      return ocFlowProd;
    default:
      return local;
  }
}

const properties = getProperties();

export default {
  ...properties,
  stage,
};

export type Properties = typeof properties;
